import React from 'react';

const Orders = () => {
  return (
    <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
      <div className="px-4 py-6 sm:px-0">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Order Management</h1>
        <div className="bg-white rounded-lg shadow-md p-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Recent Orders</h3>
              <div className="space-y-3">
                <div className="border-l-4 border-blue-500 bg-blue-50 p-4">
                  <p className="font-medium">Order #12345</p>
                  <p className="text-sm text-gray-600">Customer: John Doe</p>
                  <p className="text-sm text-gray-600">Amount: $299.99</p>
                </div>
                <div className="border-l-4 border-green-500 bg-green-50 p-4">
                  <p className="font-medium">Order #12346</p>
                  <p className="text-sm text-gray-600">Customer: Jane Smith</p>
                  <p className="text-sm text-gray-600">Amount: $159.99</p>
                </div>
              </div>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Order Stats</h3>
              <div className="space-y-2">
                <div className="flex justify-between">
                  <span>Pending Orders:</span>
                  <span className="font-semibold">23</span>
                </div>
                <div className="flex justify-between">
                  <span>Completed Orders:</span>
                  <span className="font-semibold">156</span>
                </div>
                <div className="flex justify-between">
                  <span>Cancelled Orders:</span>
                  <span className="font-semibold">12</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Orders;